import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.Login || initialState;

const makeLoginSelectField = (field) =>
  createSelector(reducerState, (loginState) => loginState[field]);

export { reducerState, makeLoginSelectField };
